<template>
  <div class="h-dialogContainer">
    <!--<div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t("System.isEffective")}}:</div>
        <ejs-dropdownlist ref="chooseSwitch" :dataSource="taskSwitch" :index="0" :placeholder='listPlaceholder'
                          @change="setFilterProps"
                          width="50%"/>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t("System.state")}}:</div>
        <ejs-dropdownlist ref="chooseState" :dataSource="sysTaskState" :index="0" :placeholder='listPlaceholder'
                          @change="setFilterProps"
                          width="50%"/>
      </div>
    </div>-->
    <div class="row h-row-inputBox" v-if="sysCustom==0">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t("System.oprType")}}:</div>
        <ejs-dropdownlist ref="chooseType" :dataSource="sysTaskOsType" :index="0" :placeholder='listPlaceholder'
                          @change="setFilterProps"
                          width="50%"/>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t("System.module")}}:</div>
        <ejs-dropdownlist ref="chooseModule" :dataSource="sysCustom == 0 ? modulesSys : moduleName" :index="0" :placeholder='listPlaceholder'
                          @change="setFilterProps"
                          width="50%"/>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t("System.lastResult")}}:</div>
        <ejs-dropdownlist ref="chooseResult" :dataSource="taskResult" :index="0" :placeholder='listPlaceholder'
                          @change="setFilterProps"
                          width="50%"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskFilter",
  props: {
    sysCustom: Number // sys 0 / custom 1
  },
  data() {
    return {
      listPlaceholder: this.$t('System.pleaseChoose'),
      clearFields: {
        text: 'text',
        value: 'value'
      },
      condition:{
        taskSwitch:"",
        taskState:"",
        taskType:"",
        moduleName:"",
        taskResult:""
      },
      taskSwitch: [
        { text: `${this.$t('System.pleaseChoose')}`, value: '' },
        { text: `${this.$t('System.no')}`, value: '0' },
        { text: `${this.$t('System.yes')}`, value: '1'}
      ],
      sysTaskState: [
        { text: `${this.$t('System.pleaseChoose')}`, value: '' },
        { text: `${this.$t('System.isRunning')}`, value: '1' },
        { text: `${this.$t('System.isReady')}`, value: '2' },
        { text: `${this.$t('System.isInvalid')}`, value: '3' },
        { text: `${this.$t('System.pause')}`, value: '0' }
      ],
      sysTaskOsType: [
        { text: `${this.$t('System.pleaseChoose')}`, value: '' },
        { text: `${this.$t('System.mmlMiss')}`, value: '1' },
        { text: `${this.$t('System.db')}`, value: '2' },
        { text: `${this.$t('System.systemFile')}`, value: '3' }
      ],
      moduleName: [
        { text: `${this.$t('System.pleaseChoose')}`, value: '' },
        { text: `${this.$t("System.config")}`, value: 1 },
        { text: `${this.$t("System.fm")}`, value: 2 },
        { text: `${this.$t("System.alarm")}`, value: 3 },
      ],
      modulesSys: [
        { text: `${this.$t('System.pleaseChoose')}`, value: '' },
        { text: `${this.$t("System.config")}`, value: 1 },
        { text: `${this.$t("System.fm")}`, value: 2 },
        { text: `${this.$t("System.alarm")}`, value: 3 },
        { text: `${this.$t('System.spectrum')}`, value: 7 },
        { text: `${this.$t("System.systemManager")}`, value: 5 }
      ],
      taskResult: [
        { text: `${this.$t('System.pleaseChoose')}`, value: '' },
        { text : `${this.$t('System.reSuccess')}`, value: `${this.$t('System.reSuccess')}`},
        { text : `${this.$t('System.reFault')}`, value: `${this.$t('System.reFault')}`}
      ]
    };
  },
  methods: {
    setFilterProps() {
      //this.condition.taskSwitch = this.taskSwitch[this.$refs.chooseSwitch.ej2Instances.index].value;
      //this.condition.taskState = this.sysTaskState[this.$refs.chooseState.ej2Instances.index].value;
      if(this.sysCustom == 0){
        this.condition.taskType = this.sysTaskOsType[this.$refs.chooseType.ej2Instances.index].value;
        this.condition.moduleName = this.modulesSys[this.$refs.chooseModule.ej2Instances.index].value;
      }else{
        this.condition.moduleName = this.moduleName[this.$refs.chooseModule.ej2Instances.index].value;
      }
      this.condition.taskResult = this.taskResult[this.$refs.chooseResult.ej2Instances.index].value;
      this.$emit("filterProps", this.condition);
    }
  },
  mounted() {
    this.setFilterProps();
  }
};
</script>
